module.exports = __webpack_public_path__ + "img/project_down.db5cb57c.png";